<template>
  <div>
    <v-data-table
      class="
        table
        table-scroll
        table-striped
        table-hover
        table-clickable
        table-no-margin
        table-detail
        table-align-middle
      "
      item-key="name"
      hide-default-footer
      disable-sort
      :headers="translationHeaders"
      :items="inventories"
      :items-per-page="options.itemsPerPage"
      :server-items-length="Number(totals.item)"
      @page-count="options.pageCount = $event"
    >
      <template #header>
        <thead class="v-data-table-header">
          <tr>
            <th v-for="header in translatedHeadersOfTotals" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="6"></td>
            <td>{{ $util.formatToLocaleString(totals.revenue_amount) }}</td>
            <td>{{ $util.formatToLocaleString(totals.revenue_quantity) }}</td>
            <td>{{ $util.formatToLocaleString(totals.return_amount) }}</td>
            <td>{{ $util.formatToLocaleString(totals.return_quantity) }}</td>
            <td>{{ $util.formatToLocaleString(totals.return_rate) + "%" }}</td>
            <td>{{ $util.formatToLocaleString(totals.discount_amount) }}</td>
            <td>{{ $util.formatToLocaleString(totals.profit_amount) }}</td>
            <td>{{ $util.formatToLocaleString(totals.profit_rate) + "%" }}</td>
          </tr>
        </tbody>
      </template>
      <template #body="{ items }">
        <tbody class="nowrap">
          <tr v-for="(item, i) in items" :key="i">
            <td>{{ item.jan_code }}</td>
            <td>{{ item.model }}</td>
            <td>{{ item.customer }}</td>
            <td>{{ item.supplier }}</td>
            <td>{{ item.category }}</td>
            <td>{{ item.employee }}</td>
            <td>{{ $util.formatToLocaleString(item.revenue_amount) }}</td>
            <td>{{ $util.formatToLocaleString(item.revenue_quantity) }}</td>
            <td>{{ $util.formatToLocaleString(item.return_amount) }}</td>
            <td>{{ $util.formatToLocaleString(item.return_quantity) }}</td>
            <td>{{ $util.formatToLocaleString(item.return_rate) + "%" }}</td>
            <td>{{ $util.formatToLocaleString(item.discount_amount) }}</td>
            <td>{{ $util.formatToLocaleString(item.profit_amount) }}</td>
            <td>{{ $util.formatToLocaleString(item.profit_rate) + "%" }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-pagination
      v-model="options.page"
      :length="options.pageCount"
      :total-visible="11"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ArchiveSummarySalesTable',
  components: {
  },

  props: {
    totals: {
      type: Object,
      default: () => ({})
    },
    inventories: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    options: {
      handler (newOption) {
        this.$emit('input', newOption)
      },
      deep: true,
      immediate: true
    }
  },

  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        pageCount: 0
      },
      headers: [
        { text: 'JAN コード', value: 'jan_code', id: 0 },
        { text: '型番', value: 'model', id: 1 },
        { text: '顧客', value: 'customer', id: 2 },
        { text: '仕入先', value: 'supplier', id: 3 },
        { text: 'カテ', value: 'category', id: 4 },
        { text: '担当者', value: 'employee', id: 5 },
        { text: '売上額', value: 'revenue_amount', id: 6 },
        { text: '売上数', value: 'revenue_quantity', id: 7 },
        { text: '返品額', value: 'return_amount', id: 8 },
        { text: '返品数', value: 'return_quantity', id: 9 },
        { text: '返品率', value: 'return_rate', id: 10 },
        { text: '合計値引（リベート）', value: 'discount_amount', id: 11 },
        { text: '粗利額', value: 'profit_amount', id: 12 },
        { text: '粗利率', value: 'profit_rate', id: 13 }
      ]
    }
  },

  computed: {
    ...mapState(['currentLanguage']),
    translationHeaders () {
      return this.headers.map(header => ({
        ...header,
        text: this.translations(`dashboard.${header.value}`)
      }))
    },
    translatedHeadersOfTotals () {
      const headersOfTotals = [
        { text: '', value: '', id: 0 },
        { text: '', value: '', id: 1 },
        { text: '', value: '', id: 2 },
        { text: '', value: '', id: 3 },
        { text: '', value: '', id: 4 },
        { text: '', value: '', id: 5 },
        { text: 'dashboard.total_sales_amount', value: '', id: 6 },
        { text: 'dashboard.total_sales_quantity', value: '', id: 7 },
        { text: 'dashboard.total_return_amount', value: '', id: 8 },
        { text: 'dashboard.total_number_returns', value: '', id: 9 },
        { text: 'dashboard.return_rate', value: '', id: 10 },
        { text: 'dashboard.total_discount_amount', value: '', id: 11 },
        { text: 'dashboard.total_gross_profit_amount', value: '', id: 12 },
        { text: 'dashboard.profit_rate', value: '', id: 13 }
      ]
      return headersOfTotals.map(headersOfTotal => ({
        ...headersOfTotal,
        text: this.translations(headersOfTotal.text)
      }))
    },

  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    }
  }
}
</script>

<style scoped>
.table-detail >>> .v-data-table-header {
  background-color: #e0e5eb;
}

.table-scroll {
  overflow-x: auto;
}
</style>
